import React from 'react';
import './SidebarContent.css';

const SidebarContent = ({ children, className = '' }) => {
    return (
        <div className={`sidebar-content ${className}`}>
            {children}
        </div>
    );
};

export default SidebarContent;
